"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeDisplay = exports.DataTypeEnum = exports.UnitsOfMeasureFEEnum = exports.UnitsOfMeasureEnum = void 0;
var UnitsOfMeasureEnum;
(function (UnitsOfMeasureEnum) {
    UnitsOfMeasureEnum["lengthCm"] = "LENGTH_CM";
    UnitsOfMeasureEnum["lengthIn"] = "LENGTH_INCH";
    UnitsOfMeasureEnum["lengthFt"] = "LENGTH_FEET";
    UnitsOfMeasureEnum["lengthYd"] = "LENGTH_YARD";
    UnitsOfMeasureEnum["pressureMMHg"] = "PRESSURE_MMHG";
    UnitsOfMeasureEnum["pressureKPA"] = "PRESSURE_KPA";
    UnitsOfMeasureEnum["pulseBPM"] = "PULSE_BPM";
    UnitsOfMeasureEnum["respirationBPM"] = "RESPIRATION_BPM";
    UnitsOfMeasureEnum["tempF"] = "TEMPERATURE_FAHRENHEIT";
    UnitsOfMeasureEnum["tempC"] = "TEMPERATURE_CELSIUS";
    UnitsOfMeasureEnum["volumeML"] = "VOLUME_ML";
    UnitsOfMeasureEnum["volumeL"] = "VOLUME_L";
    UnitsOfMeasureEnum["volumeDrops"] = "VOLUME_DROPS";
    UnitsOfMeasureEnum["volumenOZ"] = "VOLUME_OZ";
    UnitsOfMeasureEnum["volumeCC"] = "VOLUME_CC";
    UnitsOfMeasureEnum["volumeTsp"] = "VOLUME_TSP";
    UnitsOfMeasureEnum["volumeTbsp"] = "VOLUME_TBS";
    UnitsOfMeasureEnum["volumeCup"] = "VOLUME_CUP";
    UnitsOfMeasureEnum["volumeQT"] = "VOLUME_QUART";
    UnitsOfMeasureEnum["volumePT"] = "VOLUME_PINT";
    UnitsOfMeasureEnum["weightKG"] = "WEIGHT_KG";
    UnitsOfMeasureEnum["weightG"] = "WEIGHT_G";
    UnitsOfMeasureEnum["weightMG"] = "WEIGHT_MG";
    UnitsOfMeasureEnum["weightMCG"] = "WEIGHT_MCG";
    UnitsOfMeasureEnum["weightOz"] = "WEIGHT_OZ";
    UnitsOfMeasureEnum["weightLb"] = "WEIGHT_LB";
})(UnitsOfMeasureEnum || (exports.UnitsOfMeasureEnum = UnitsOfMeasureEnum = {}));
var UnitsOfMeasureFEEnum;
(function (UnitsOfMeasureFEEnum) {
    UnitsOfMeasureFEEnum["lengthCm"] = "LENGTH_CM";
    UnitsOfMeasureFEEnum["lengthIn"] = "LENGTH_INCH";
    UnitsOfMeasureFEEnum["lengthFt"] = "LENGTH_FEET";
    UnitsOfMeasureFEEnum["lengthFtIn"] = "LENGTH_FEET_AND_INCH";
    UnitsOfMeasureFEEnum["lengthMCm"] = "LENGTH_METER_AND_CENTIMETER";
    UnitsOfMeasureFEEnum["lengthYd"] = "LENGTH_YARD";
    UnitsOfMeasureFEEnum["pressureMMHg"] = "PRESSURE_MMHG";
    UnitsOfMeasureFEEnum["pressureKPA"] = "PRESSURE_KPA";
    UnitsOfMeasureFEEnum["pulseBPM"] = "PULSE_BPM";
    UnitsOfMeasureFEEnum["respirationBPM"] = "RESPIRATION_BPM";
    UnitsOfMeasureFEEnum["tempF"] = "TEMPERATURE_FAHRENHEIT";
    UnitsOfMeasureFEEnum["tempC"] = "TEMPERATURE_CELSIUS";
    UnitsOfMeasureFEEnum["volumeML"] = "VOLUME_ML";
    UnitsOfMeasureFEEnum["volumeL"] = "VOLUME_L";
    UnitsOfMeasureFEEnum["volumeDrops"] = "VOLUME_DROPS";
    UnitsOfMeasureFEEnum["volumenOZ"] = "VOLUME_OZ";
    UnitsOfMeasureFEEnum["volumeCC"] = "VOLUME_CC";
    UnitsOfMeasureFEEnum["volumeTsp"] = "VOLUME_TSP";
    UnitsOfMeasureFEEnum["volumeTbsp"] = "VOLUME_TBS";
    UnitsOfMeasureFEEnum["volumeCup"] = "VOLUME_CUP";
    UnitsOfMeasureFEEnum["volumeQT"] = "VOLUME_QUART";
    UnitsOfMeasureFEEnum["volumePT"] = "VOLUME_PINT";
    UnitsOfMeasureFEEnum["weightKG"] = "WEIGHT_KG";
    UnitsOfMeasureFEEnum["weightG"] = "WEIGHT_G";
    UnitsOfMeasureFEEnum["weightMG"] = "WEIGHT_MG";
    UnitsOfMeasureFEEnum["weightMCG"] = "WEIGHT_MCG";
    UnitsOfMeasureFEEnum["weightOz"] = "WEIGHT_OZ";
    UnitsOfMeasureFEEnum["weightLb"] = "WEIGHT_LB";
})(UnitsOfMeasureFEEnum || (exports.UnitsOfMeasureFEEnum = UnitsOfMeasureFEEnum = {}));
var DataTypeEnum;
(function (DataTypeEnum) {
    DataTypeEnum["string"] = "STRING";
    DataTypeEnum["int"] = "INT";
    DataTypeEnum["float"] = "FLOAT";
    DataTypeEnum["boolean"] = "BOOLEAN";
    DataTypeEnum["dateTime"] = "DATETIME";
    DataTypeEnum["date"] = "DATE";
    DataTypeEnum["time"] = "TIME";
})(DataTypeEnum || (exports.DataTypeEnum = DataTypeEnum = {}));
var DateTimeDisplay;
(function (DateTimeDisplay) {
    DateTimeDisplay["DATE"] = "date";
    DateTimeDisplay["TIME"] = "time";
    DateTimeDisplay["DATETIME"] = "dateTime";
})(DateTimeDisplay || (exports.DateTimeDisplay = DateTimeDisplay = {}));
